import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "02",
    title: "Writing",
    body: "Original screenplays and adaptations built on a singular voice. From first draft to production polish, the word comes first — precise, textured and unafraid of silence.",
  },
  {
    n: "03",
    title: "Producing",
    body: "Shepherding stories from spark to screen — development, packaging, financing and the careful assembly of the right creative team to protect the vision.",
  },
  {
    n: "04",
    title: "World Building",
    body: "Rich, believable worlds grounded in research and place. Cultural specificity treated not as decoration but as the beating heart of the narrative.",
  },
  {
    n: "05",
    title: "Collaboration",
    body: "Partnering with directors, financiers and broadcasters who share a commitment to craft, patience and bold, character-driven storytelling.",
  },
];

export default function TheWork() {
  return (
    <section
      id="work"
      data-testid="work-section"
      className="relative z-10 bg-surface-warm py-24 md:py-36 border-t border-[#DCDEE6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-20">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="font-mono text-xs tracking-[0.3em] uppercase text-ochre"
          >
            The Work
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight mt-6 text-onyx"
          >
            Four disciplines, one <span className="italic text-ochre">obsession</span> — the story.
          </motion.h2>
        </div>

        <div className="divide-y divide-[#CFD3DE] border-t border-b border-[#CFD3DE]">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`work-chapter-${c.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.05 }}
              className="group grid md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 items-baseline"
            >
              <div className="md:col-span-2 font-mono text-sm text-ochre">{c.n}</div>
              <h3 className="md:col-span-4 font-serif text-3xl sm:text-4xl lg:text-5xl text-onyx transition-transform duration-500 group-hover:translate-x-2">
                {c.title}
              </h3>
              <p className="md:col-span-6 font-sans text-base sm:text-lg leading-relaxed text-onyx-muted">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
